import React from 'react'
import Helmet from 'react-helmet'
import {connect} from 'react-redux'
import PT from 'prop-types'
import {Icon} from 'antd-mobile'
import HeaderNav from '../../components/HeaderNav'
import {closeWindow, isFullScreen as isFullScreenFn} from '../../utils/pwHybrid'
import FullscreenHeaderWrap from '../../components/FullscreenHeaderWrap'
import {isFrdyo, isHuna, isLH, isSocial, isX} from '../../utils/ua'
import './index.scss'

class NotFound extends React.Component {
  componentDidMount() {
  }

  render() {
    return (
      <div>
        <div className="NotFound">
          <Helmet>
            <title>be missing</title>
            <body className="page-NotFound" />
          </Helmet>
          <div className="NotFound__imgHuna" />
          <div className="NotFound__txt">The page went on a trip</div>
        </div>
      </div>
    )
  }
}

NotFound.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  userAgent: PT.string.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  hostname: PT.string.isRequired,
}

export default connect((state, props) => {
  const {
    env: {userAgent, hostname},
  } = state
  return {
    userAgent,
    hostname,
  }
})(NotFound)
